var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3863 23.3846V12.1111L0.674316 7.01426V18.4606L11.3863 23.3846Z",
    fill: "#B7844D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1206 10.1674L22.8326 5.3297L12.1206 0.189697L1.27901 5.3297L12.1206 10.1674Z",
    fill: "#B7844D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9845 12.1111V23.3846L23.5669 18.4606V7.23022L12.9845 12.1111Z",
    fill: "#B7844D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3863 23.3846V12.1111L0.674316 7.01426V18.4606L11.3863 23.3846Z",
    stroke: "#B7844D",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1206 10.1674L22.8326 5.3297L12.1206 0.189697L1.27901 5.3297L12.1206 10.1674Z",
    stroke: "#B7844D",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9845 12.1111V23.3846L23.5669 18.4606V7.23022L12.9845 12.1111Z",
    stroke: "#B7844D",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/Cube.47ebd4b08a4a51cebbf35c4d6bba143b.svg";
export { ForwardRef as ReactComponent };